import { ThemeConfig } from './types'
import { typography, breakpoints, components } from './base.theme'

export const adventureTheme: ThemeConfig = {
  id: 'adventure',
  name: 'Adventure',
  description: 'Nature-inspired adventure theme',
  preview: {
    primaryColor: '#2d6a4f',
    secondaryColor: '#8b6914',
  },
  light: {
    palette: {
      mode: 'light',
      primary: {
        main: '#2d6a4f',
        light: '#4a8a6c',
        dark: '#1b4332',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#8b6914',
        light: '#a8842e',
        dark: '#6b4f0e',
        contrastText: '#ffffff',
      },
      background: {
        default: '#f5f0e8',
        paper: '#ffffff',
      },
      text: {
        primary: '#2d3b2d',
        secondary: '#4a5c4a',
      },
      success: {
        main: '#40916c',
      },
      info: {
        main: '#2980b9',
      },
      warning: {
        main: '#d97706',
      },
      error: {
        main: '#c75b5b',
      },
    },
    typography,
    breakpoints,
    components,
  },
  dark: {
    palette: {
      mode: 'dark',
      primary: {
        main: '#d4a853',
        light: '#e0be78',
        dark: '#b08a3a',
        contrastText: '#1a1a2e',
      },
      secondary: {
        main: '#38b2ac',
        light: '#5cc8c3',
        dark: '#2a8a85',
        contrastText: '#1a1a2e',
      },
      background: {
        default: '#1a1a2e',
        paper: '#1e2a45',
      },
      text: {
        primary: '#e8e8e8',
        secondary: '#a0aec0',
      },
      success: {
        main: '#48bb78',
      },
      info: {
        main: '#4299e1',
      },
      warning: {
        main: '#ed8936',
      },
      error: {
        main: '#fc8181',
      },
    },
    typography,
    breakpoints,
    components,
  },
}
